module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av596-a105342e65ebf366c469ee22814136a9.jpg";